import { Theme } from '@mui/material';

export type DataGridType = 'primary' | 'secondary';

const baseGridStyles = {
  border: 'none',
  '& .MuiDataGrid-footerContainer': {
    border: 'none',
  },
  '& .MuiDataGrid-cell': {
    border: 'none',
  },
};

export const generateStyles = (theme: Theme, dataGridType: DataGridType) => {
  switch (dataGridType) {
    case 'primary':
      return {
        ...baseGridStyles,
        '& .MuiDataGrid-columnHeader--pinnedRight': {
          borderLeft: 'none',
        },

        '&& .MuiDataGrid-virtualScrollerRenderZone, && .MuiDataGrid-virtualScrollerRenderZone:only-child':
          {
            '& .MuiDataGrid-row': {
              '& .MuiDataGrid-cell:last-child': {
                backgroundColor: theme.palette.background.paper,
                borderRight:
                  theme.palette.mode === 'light' ? '2px solid #ddd' : 'none',
                '&.MuiDataGrid-cellSkeleton': {
                  backgroundColor: 'unset',
                },
              },
              backgroundColor: theme.palette.background.paper,
              boxShadow:
                '3px 3px 3px -2px rgba(0,0,0,0.2), 3px 3px 4px 0px rgba(0,0,0,0.14), 3px 1px 8px 0px rgba(0,0,0,0.12)',
              '& .MuiDataGrid-cell': {
                borderLeft: `2px solid ${theme.palette.primary.main}`,
              },
              '& .MuiDataGrid-cell ~ .MuiDataGrid-cell': {
                borderLeft: 'none',
              },
              '&.success .MuiDataGrid-cell': {
                borderLeft: `2px solid ${
                  theme.palette.mode === 'light'
                    ? theme.palette.success.main
                    : theme.palette.success.dark
                }`,
              },
              '&.success .MuiDataGrid-cell ~ .MuiDataGrid-cell': {
                borderLeft: 'none',
              },
              '&.warning .MuiDataGrid-cell': {
                borderLeft: `2px solid ${
                  theme.palette.mode === 'light'
                    ? theme.palette.warning.main
                    : theme.palette.warning.dark
                }`,
              },
              '&.warning .MuiDataGrid-cell ~ .MuiDataGrid-cell': {
                borderLeft: 'none',
              },
              '&.error .MuiDataGrid-cell': {
                borderLeft: `2px solid ${
                  theme.palette.mode === 'light'
                    ? theme.palette.error.main
                    : theme.palette.error.dark
                }`,
              },
              '&.error .MuiDataGrid-cell ~ .MuiDataGrid-cell': {
                borderLeft: 'none',
              },
              '&.info .MuiDataGrid-cell': {
                borderLeft: `2px solid ${
                  theme.palette.mode === 'light'
                    ? theme.palette.info.main
                    : theme.palette.info.dark
                }`,
              },
              '&.info .MuiDataGrid-cell ~ .MuiDataGrid-cell': {
                borderLeft: 'none',
              },
            },
          },
        '& .MuiDataGrid-virtualScrollerRenderZone:only-child': {
          '& .MuiDataGrid-row': {
            boxShadow: theme.shadows[3],
            '& .MuiDataGrid-cell:last-child': {
              borderRight:
                theme.palette.mode === 'light' ? '2px solid #ddd' : 'none',
            },
          },
        },
        '.MuiDataGrid-columnHeader': {
          paddingRight: '16px',
        },
        '.MuiDataGrid-columnHeader--sorted': {
          '.MuiDataGrid-sortIcon': {
            color: theme.palette.primary.main,
          },
        },
      };
    case 'secondary':
      return {
        ...baseGridStyles,
        '& .MuiDataGrid-columnHeaderTitle': {
          fontWeight: 700,
        },
        '& .row-bold *': {
          fontWeight: 'bold',
        },
      };
  }
};

export const isInitialLoad = (rows, loading) =>
  (rows || []).length === 0 && loading;
